module.exports = __webpack_public_path__ + "static/cinsa_home_tu_calentador_ideal_deposito_XS-43ca8c5f4c978b66340466fe813a7d99.png";